import { toSnakeCase } from 'common/util/string.util';

class LocalStorageService {
    constructor(prefix) {
        this.prefix = prefix || null;
    }

    setPrefix(prefix) {
        this.prefix = this.normalizeKey(prefix);
    }

    getStorage() {
        return window.localStorage;
    }

    getItem(key) {
        return this.get(this.getPrefixedKey(this.prefix, key));
    }

    setItem(key, value) {
        return this.set(this.getPrefixedKey(this.prefix, key), value);
    }

    get(key) {
        try {
            return this.deserialize(key, this.getStorage().getItem(key));
        } catch (exception) {
            return null;
        }
    }

    set(key, value) {
        try {
            return value == null
                ? this.getStorage().removeItem(key)
                : this.getStorage().setItem(key, this.serialize(key, value));
        } catch (exception) {
            return null;
        }
    }

    serialize(key, value) {
        return JSON.stringify(value);
    }

    deserialize(key, value) {
        return JSON.parse(value);
    }

    normalizeKey(key) {
        return toSnakeCase(key);
    }

    getPrefixedKey(...keys) {
        return keys.map(this.normalizeKey.bind(this)).join('-');
    }
}

class UserLocalStorageService extends LocalStorageService {
    constructor(prefix) {
        super(prefix);

        this.userPrefix = null;
    }

    setUserPrefix(prefix) {
        this.userPrefix = this.normalizeKey(prefix);
    }

    getUserItem(key) {
        return this.userPrefix && this.userPrefix.length > 0
            ? this.getItem(this.getPrefixedKey(this.userPrefix, key))
            : null;
    }

    setUserItem(key, value) {
        if (!this.userPrefix || this.userPrefix.length < 1) {
            throw 'Unable to access user data.';
        }

        return this.setItem(this.getPrefixedKey(this.userPrefix, key), value);
    }
}

export default class StorageServiceProvider extends LocalStorageService {
    $get() {
        return new UserLocalStorageService(this.prefix);
    }
}



// WEBPACK FOOTER //
// ./src/common/service/storage/storage.provider.js